module.exports = __webpack_public_path__ + "img/kegbit-logo-color.e4277c0f.svg";